export default __webpack_public_path__ + "static/media/up-green.02f26fb2.svg";